import { defineComponent, computed, ref, watch, resolveComponent, createElementBlock, openBlock, createCommentVNode, createElementVNode, createVNode, createBlock, Fragment, toDisplayString, unref, renderList, normalizeClass, createTextVNode } from "vue";
import { dateFormatter, vatExemptNote, Money, PaymentTypeLabel, PaymentAdditionLabel } from "app-core";
import { useI18n } from "vue-i18n";
import { useUtilities } from "./index52.js";
import _sfc_main$1 from "./index11.js";
import _sfc_main$2 from "./index109.js";
import moment from "moment-timezone";
const _hoisted_1 = { class: "receipt-invoice-sr printable-area" };
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = {
  key: 1,
  class: "receipt-header"
};
const _hoisted_4 = { class: "nonfiscal-heading" };
const _hoisted_5 = { class: "heading-numbers" };
const _hoisted_6 = { key: 0 };
const _hoisted_7 = { key: 1 };
const _hoisted_8 = { class: "heading-dates" };
const _hoisted_9 = { key: 0 };
const _hoisted_10 = { key: 1 };
const _hoisted_11 = { key: 2 };
const _hoisted_12 = { class: "receipt-subheader" };
const _hoisted_13 = { class: "receipt-details" };
const _hoisted_14 = {
  key: 0,
  class: "receipt-buyer"
};
const _hoisted_15 = {
  key: 1,
  class: "receipt-items"
};
const _hoisted_16 = { class: "heading-row" };
const _hoisted_17 = { align: "left" };
const _hoisted_18 = { align: "left" };
const _hoisted_19 = { align: "left" };
const _hoisted_20 = { align: "right" };
const _hoisted_21 = { align: "right" };
const _hoisted_22 = { align: "right" };
const _hoisted_23 = { align: "left" };
const _hoisted_24 = { align: "left" };
const _hoisted_25 = { key: 0 };
const _hoisted_26 = {
  align: "left",
  class: "name"
};
const _hoisted_27 = { key: 0 };
const _hoisted_28 = ["innerHTML"];
const _hoisted_29 = {
  key: 2,
  style: { "font-size": "11px" }
};
const _hoisted_30 = { align: "right" };
const _hoisted_31 = { align: "right" };
const _hoisted_32 = { align: "right" };
const _hoisted_33 = {
  key: 2,
  class: "receipt-items"
};
const _hoisted_34 = { class: "heading-row" };
const _hoisted_35 = { align: "left" };
const _hoisted_36 = { align: "left" };
const _hoisted_37 = { align: "left" };
const _hoisted_38 = { align: "right" };
const _hoisted_39 = { align: "right" };
const _hoisted_40 = { align: "right" };
const _hoisted_41 = { align: "right" };
const _hoisted_42 = { align: "right" };
const _hoisted_43 = { align: "right" };
const _hoisted_44 = { align: "right" };
const _hoisted_45 = { align: "right" };
const _hoisted_46 = { align: "right" };
const _hoisted_47 = { align: "left" };
const _hoisted_48 = { align: "left" };
const _hoisted_49 = {
  align: "left",
  class: "name"
};
const _hoisted_50 = { key: 0 };
const _hoisted_51 = { key: 1 };
const _hoisted_52 = {
  key: 2,
  style: { "font-size": "11px" }
};
const _hoisted_53 = { align: "right" };
const _hoisted_54 = { align: "right" };
const _hoisted_55 = { align: "right" };
const _hoisted_56 = { align: "right" };
const _hoisted_57 = { align: "right" };
const _hoisted_58 = { align: "right" };
const _hoisted_59 = { align: "right" };
const _hoisted_60 = { align: "right" };
const _hoisted_61 = { align: "right" };
const _hoisted_62 = { colspan: "10" };
const _hoisted_63 = ["innerHTML"];
const _hoisted_64 = { class: "receipt-footer" };
const _hoisted_65 = { class: "footer-item additional-info" };
const _hoisted_66 = {
  key: 0,
  class: "code"
};
const _hoisted_67 = {
  key: 1,
  class: "code"
};
const _hoisted_68 = {
  key: 2,
  class: "code mb-3"
};
const _hoisted_69 = { class: "code" };
const _hoisted_70 = { class: "code pfr-number" };
const _hoisted_71 = { key: 0 };
const _hoisted_72 = { key: 1 };
const _hoisted_73 = { class: "code" };
const _hoisted_74 = { key: 0 };
const _hoisted_75 = { key: 1 };
const _hoisted_76 = { class: "code" };
const _hoisted_77 = { key: 0 };
const _hoisted_78 = { key: 1 };
const _hoisted_79 = {
  key: 0,
  class: "buyer-signatures"
};
const _hoisted_80 = { class: "buyer-signature" };
const _hoisted_81 = { class: "footer-item qrcode" };
const _hoisted_82 = {
  key: 1,
  class: "verification-link"
};
const _hoisted_83 = ["href"];
const _hoisted_84 = { class: "footer-item summary" };
const _hoisted_85 = {
  key: 0,
  class: "summary-item to-pay"
};
const _hoisted_86 = {
  key: 0,
  class: "amount"
};
const _hoisted_87 = {
  key: 1,
  class: "amount"
};
const _hoisted_88 = {
  key: 1,
  class: "summary-item to-pay"
};
const _hoisted_89 = {
  key: 0,
  class: "amount"
};
const _hoisted_90 = {
  key: 1,
  class: "amount"
};
const _hoisted_91 = { class: "amount" };
const _hoisted_92 = {
  key: 2,
  class: "tax-items"
};
const _hoisted_93 = { class: "heading-row" };
const _hoisted_94 = { align: "left" };
const _hoisted_95 = { align: "center" };
const _hoisted_96 = { align: "right" };
const _hoisted_97 = { align: "right" };
const _hoisted_98 = { align: "left" };
const _hoisted_99 = { align: "center" };
const _hoisted_100 = { align: "right" };
const _hoisted_101 = { align: "right" };
const _hoisted_102 = {
  key: 0,
  class: "bordered"
};
const _hoisted_103 = { colspan: "3" };
const _hoisted_104 = {
  key: 0,
  align: "right"
};
const _hoisted_105 = { class: "bordered" };
const _hoisted_106 = { colspan: "3" };
const _hoisted_107 = { align: "right" };
const _hoisted_108 = { class: "nonfiscal-info" };
const _hoisted_109 = { class: "nonfiscal-left" };
const _hoisted_110 = { key: 0 };
const _hoisted_111 = { key: 1 };
const _hoisted_112 = { key: 2 };
const _hoisted_113 = { key: 3 };
const _hoisted_114 = { class: "signatures" };
const _hoisted_115 = { class: "signature" };
const _hoisted_116 = { class: "signature" };
const priceFormat = "0,0.00";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ReceiptInvoiceLocalizationSr",
  props: {
    order: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      default: () => {
      }
    },
    venue: {
      type: Object,
      default: () => void 0
    },
    isRetail: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const { t } = useI18n();
    const { formatDate, formatDateTime } = dateFormatter();
    const { nl2br } = useUtilities();
    const props = __props;
    const vatNote = computed(() => props.order.isIncoming() ? null : vatExemptNote(props.venue, `${t("receipt.note")}: ${t("receipt.exempt_from_tax_comment")}`));
    const invoice = ref(props.order.register_request || props.order.getRegisterRequest());
    const sdcResponse = ref(props.order.register_response);
    const paymentTypes = ref(getPaymentTypes());
    function getPaymentTypes() {
      var _a;
      const totalPaid = props.order.getPaid().abs();
      const totalAmount = props.order.getToPay().abs();
      const remaining = props.order.isAdvance() ? Money.parse(0) : Money.parse(totalAmount.toRoundedUnit(2)).subtract(Money.parse(totalPaid.toRoundedUnit(2)));
      let allPaymentTypes = [];
      let paymentTypes2 = props.order.getPayments();
      const advancePayment = paymentTypes2.find((p) => p.key === PaymentTypeLabel.advance);
      if (advancePayment) {
        allPaymentTypes.push(advancePayment);
        paymentTypes2 = paymentTypes2.filter((p) => p.key !== PaymentTypeLabel.advance);
      }
      if ((_a = sdcResponse.value) == null ? void 0 : _a.advanceTax) {
        allPaymentTypes.push({
          key: PaymentAdditionLabel.advance_tax,
          display: t("receipt.payments.advance_tax"),
          amount: Money.parse(sdcResponse.value.advanceTax).toUnit()
        });
      }
      allPaymentTypes = [
        ...allPaymentTypes,
        ...paymentTypes2.filter((p) => p.key !== PaymentTypeLabel.advance)
      ];
      if (remaining.toUnit() !== 0) {
        allPaymentTypes.push({
          key: PaymentAdditionLabel.change,
          display: remaining.toUnit() < 0 ? t("receipt.payments.change") : t("receipt.payments.left_to_pay"),
          amount: remaining.abs().toUnit()
        });
      }
      return allPaymentTypes;
    }
    const advanceRefundInvoice = ref(getAdvanceRefundInvoice());
    function getAdvanceRefundInvoice() {
      if (!props.order.refersToAdvance()) return null;
      if (!props.order.refers_to[0]) return null;
      const advanceRefund = props.order.refers_to[0];
      return advanceRefund.register_request || advanceRefund.getRegisterRequest();
    }
    const supplierInfo = ref(getSupplierInfo());
    function getSupplierInfo() {
      var _a, _b, _c, _d;
      let supplierInfo2 = [];
      if (sdcResponse.value) {
        supplierInfo2 = [
          `${t("receipt.tax_id_number")}: ${sdcResponse.value.tin}`,
          `${t("receipt.company")}: ${sdcResponse.value.businessName}`,
          `${t("receipt.venue")}: ${sdcResponse.value.locationName}`,
          `${t("receipt.address")}: ${sdcResponse.value.address}`,
          `${t("receipt.municipality")}: ${sdcResponse.value.district}`
        ];
      } else if (!props.order.isIncoming()) {
        supplierInfo2 = [
          `${t("receipt.tax_id_number")}: ${(_a = props.venue) == null ? void 0 : _a.tax_id_number}`,
          `${t("receipt.company")}: ${(_b = props.venue) == null ? void 0 : _b.company_name}`,
          `${t("receipt.venue")}: ${(_c = props.venue) == null ? void 0 : _c.name}`,
          `${t("receipt.address")}: ${(_d = props.venue) == null ? void 0 : _d.address}`
        ];
      }
      supplierInfo2.push(`${t("receipt.cashier")}: ${invoice.value.cashier}`);
      return supplierInfo2;
    }
    const client = ref(props.order.getClient() || props.order.client || null);
    const buyerInfo = ref(getBuyerInfo());
    function getBuyerInfo() {
      var _a, _b, _c, _d, _e, _f, _g;
      const buyerInfo2 = [];
      if (!props.order.isIncoming()) {
        if ((_a = client.value) == null ? void 0 : _a.name) {
          buyerInfo2.push(client.value.name);
        }
        if ((_b = client.value) == null ? void 0 : _b.address) {
          let address = client.value.address;
          if (client.value.city) address += `, ${client.value.city}`;
          if (client.value.country) address += `, ${client.value.country}`;
          buyerInfo2.push(address);
        }
        if ((_c = client.value) == null ? void 0 : _c.registration_number) {
          buyerInfo2.push(t("receipt.registration_number") + ": " + client.value.registration_number);
        }
      } else {
        buyerInfo2.push((_d = props.venue) == null ? void 0 : _d.name);
        buyerInfo2.push((_e = props.venue) == null ? void 0 : _e.address);
      }
      if ((_f = invoice.value) == null ? void 0 : _f.buyerId) {
        buyerInfo2.push(t("receipt.buyer_id") + ": " + invoice.value.buyerId);
      }
      if ((_g = invoice.value) == null ? void 0 : _g.buyerCostCenterId) {
        buyerInfo2.push(t("receipt.buyer_cost_center") + ": " + invoice.value.buyerCostCenterId);
      }
      return buyerInfo2;
    }
    const summary = ref(getSummary());
    function getSummary() {
      if (!sdcResponse.value) {
        return {
          totalAmount: Money.parse(0),
          totalTax: Money.parse(0)
        };
      }
      const totalAmount = props.order.getToPay().abs();
      const totalTax = props.order.getTax().abs();
      const totalPriceBeforeTax = props.order.getPriceBeforeTax().abs();
      return {
        totalAmount,
        totalTax,
        totalPriceBeforeTax
      };
    }
    const qrCode = ref("");
    watch(() => props.order, async (val) => {
      qrCode.value = await val.generateQRCodeString();
    }, { immediate: true });
    return (_ctx, _cache) => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i;
      const _component_vue_qrcode = resolveComponent("vue-qrcode");
      return openBlock(), createElementBlock("div", _hoisted_1, [
        !__props.order.isIncoming() ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          ((_a = __props.venue) == null ? void 0 : _a.invoice_header) ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: "ck-content ck-custom",
            innerHTML: (_b = __props.venue) == null ? void 0 : _b.invoice_header
          }, null, 8, _hoisted_2)) : (openBlock(), createElementBlock("div", _hoisted_3, [
            createElementVNode("p", null, toDisplayString((_c = __props.venue) == null ? void 0 : _c.company_name), 1),
            createElementVNode("p", null, toDisplayString((_d = __props.venue) == null ? void 0 : _d.name), 1),
            createElementVNode("p", null, toDisplayString((_e = __props.venue) == null ? void 0 : _e.address), 1)
          ]))
        ], 64)) : createCommentVNode("", true),
        createElementVNode("div", _hoisted_4, [
          createElementVNode("div", _hoisted_5, [
            __props.order.number ? (openBlock(), createElementBlock("p", _hoisted_6, toDisplayString(unref(t)("receipt.serial_number") + ": " + __props.order.number), 1)) : createCommentVNode("", true),
            __props.order.internal_number ? (openBlock(), createElementBlock("p", _hoisted_7, toDisplayString(`${!__props.order.isProforma() ? unref(t)("receipt.internal_number") : unref(t)("receipt.proforma_number")}: ${__props.order.internal_number}`), 1)) : createCommentVNode("", true)
          ]),
          createElementVNode("div", _hoisted_8, [
            __props.order.getTransactionDate() ? (openBlock(), createElementBlock("p", _hoisted_9, toDisplayString(unref(t)("general.transaction_date") + ": ") + " " + toDisplayString(unref(formatDate)(__props.order.getTransactionDate())), 1)) : createCommentVNode("", true),
            __props.order.due_date ? (openBlock(), createElementBlock("p", _hoisted_10, toDisplayString(!__props.order.isAdvance() ? unref(t)("receipt.due_date") : unref(t)("general.paid_date_advance")) + ": " + toDisplayString(unref(formatDate)(__props.order.due_date)), 1)) : createCommentVNode("", true),
            __props.order.start_date && __props.order.end_date ? (openBlock(), createElementBlock("p", _hoisted_11, toDisplayString(unref(t)("receipt.period")) + ": " + toDisplayString(unref(formatDate)(__props.order.start_date)) + " - " + toDisplayString(unref(formatDate)(__props.order.end_date)), 1)) : createCommentVNode("", true)
          ])
        ]),
        createVNode(_sfc_main$1, {
          text: ["Normal", "Advance"].includes(invoice.value.invoiceType) ? unref(t)("receipt.fiscal_receipt") : unref(t)("receipt.nonfiscal_receipt"),
          large: !["Normal", "Advance"].includes(invoice.value.invoiceType),
          delimiter: "="
        }, null, 8, ["text", "large"]),
        createElementVNode("div", _hoisted_12, [
          createElementVNode("div", _hoisted_13, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(supplierInfo.value, (info) => {
              return openBlock(), createElementBlock("p", { key: info }, toDisplayString(info), 1);
            }), 128))
          ]),
          buyerInfo.value.length ? (openBlock(), createElementBlock("div", _hoisted_14, [
            createElementVNode("p", null, [
              createElementVNode("strong", null, toDisplayString(unref(t)("receipt.buyer")), 1)
            ]),
            (openBlock(true), createElementBlock(Fragment, null, renderList(buyerInfo.value, (info) => {
              return openBlock(), createElementBlock("p", { key: info }, toDisplayString(info), 1);
            }), 128))
          ])) : createCommentVNode("", true)
        ]),
        createVNode(_sfc_main$1, {
          text: unref(t)(`receipt.type_${invoice.value.invoiceType.toLowerCase()}`) + " " + unref(t)(`receipt.transaction_${invoice.value.transactionType.toLowerCase()}`)
        }, null, 8, ["text"]),
        !((_f = __props.venue) == null ? void 0 : _f.wholesale) ? (openBlock(), createElementBlock("table", _hoisted_15, [
          createElementVNode("tbody", null, [
            createElementVNode("tr", _hoisted_16, [
              createElementVNode("td", _hoisted_17, toDisplayString(unref(t)("receipt.items.number")), 1),
              createElementVNode("td", _hoisted_18, toDisplayString(unref(t)("receipt.items.code")), 1),
              createElementVNode("td", _hoisted_19, toDisplayString(unref(t)("receipt.items.name")), 1),
              createElementVNode("td", _hoisted_20, toDisplayString(unref(t)("receipt.items.unit_price")), 1),
              createElementVNode("td", _hoisted_21, toDisplayString(unref(t)("receipt.items.quantity")), 1),
              createElementVNode("td", _hoisted_22, toDisplayString(unref(t)("receipt.items.to_pay")), 1)
            ]),
            (openBlock(true), createElementBlock(Fragment, null, renderList(invoice.value.items, (item, index) => {
              var _a2, _b2;
              return openBlock(), createElementBlock("tr", {
                key: `invoice-${index}`,
                class: normalizeClass({ "border-bottom": index !== invoice.value.items.length - 1 })
              }, [
                createElementVNode("td", _hoisted_23, toDisplayString(index + 1) + ".", 1),
                createElementVNode("td", _hoisted_24, [
                  ((_a2 = __props.order.items[index]) == null ? void 0 : _a2.getProduct()) ? (openBlock(), createElementBlock("span", _hoisted_25, toDisplayString((_b2 = __props.order.items[index].getProduct()) == null ? void 0 : _b2.code), 1)) : createCommentVNode("", true)
                ]),
                createElementVNode("td", _hoisted_26, [
                  createElementVNode("span", null, toDisplayString(item.name), 1),
                  createElementVNode("span", null, toDisplayString(item.labels.map((label) => ` (${label})`).join("")), 1),
                  item.unit ? (openBlock(), createElementBlock("span", _hoisted_27, "/" + toDisplayString(item.unit), 1)) : createCommentVNode("", true),
                  __props.isRetail && item.note ? (openBlock(), createElementBlock("div", {
                    key: 1,
                    innerHTML: unref(nl2br)(item.note)
                  }, null, 8, _hoisted_28)) : createCommentVNode("", true),
                  item.gtin ? (openBlock(), createElementBlock("div", _hoisted_29, "GTIN: " + toDisplayString(item.gtin), 1)) : createCommentVNode("", true)
                ]),
                createElementVNode("td", _hoisted_30, toDisplayString(unref(Money).parse(item.unitPrice).toFormat(priceFormat)), 1),
                createElementVNode("td", _hoisted_31, toDisplayString(item.quantity), 1),
                createElementVNode("td", _hoisted_32, toDisplayString(unref(Money).parse(item.totalAmount).multiply(invoice.value.transactionType === "Sale" ? 1 : -1).toFormat(priceFormat)), 1)
              ], 2);
            }), 128)),
            _cache[0] || (_cache[0] = createElementVNode("tr", { class: "divider" }, [
              createElementVNode("td", { colspan: 12 })
            ], -1))
          ])
        ])) : (openBlock(), createElementBlock("table", _hoisted_33, [
          createElementVNode("tbody", null, [
            createElementVNode("tr", _hoisted_34, [
              createElementVNode("td", _hoisted_35, toDisplayString(unref(t)("receipt.items.number")), 1),
              createElementVNode("td", _hoisted_36, toDisplayString(unref(t)("receipt.items.code")), 1),
              createElementVNode("td", _hoisted_37, toDisplayString(unref(t)("receipt.items.name")), 1),
              createElementVNode("td", _hoisted_38, toDisplayString(unref(t)("receipt.items.quantity")), 1),
              createElementVNode("td", _hoisted_39, toDisplayString(unref(t)("receipt.items.wholesale.unit_price_before_tax")), 1),
              createElementVNode("td", _hoisted_40, toDisplayString(unref(t)("receipt.items.wholesale.tax_rate")), 1),
              createElementVNode("td", _hoisted_41, toDisplayString(unref(t)("receipt.items.wholesale.unit_price")), 1),
              createElementVNode("td", _hoisted_42, toDisplayString(unref(t)("receipt.items.wholesale.discount")), 1),
              createElementVNode("td", _hoisted_43, toDisplayString(unref(t)("receipt.items.wholesale.unit_price_after_discount")), 1),
              createElementVNode("td", _hoisted_44, toDisplayString(unref(t)("receipt.items.wholesale.price_before_tax")), 1),
              createElementVNode("td", _hoisted_45, toDisplayString(unref(t)("receipt.items.wholesale.tax")), 1),
              createElementVNode("td", _hoisted_46, toDisplayString(unref(t)("receipt.items.wholesale.to_pay")), 1)
            ]),
            (openBlock(true), createElementBlock(Fragment, null, renderList(__props.order.items, (item, index) => {
              var _a2, _b2;
              return openBlock(), createElementBlock(Fragment, {
                key: `invoice-${index}`
              }, [
                createElementVNode("tr", {
                  class: normalizeClass({ "border-bottom": (!__props.isRetail || !item.comments.length) && index != __props.order.items.length - 1 })
                }, [
                  createElementVNode("td", _hoisted_47, toDisplayString(index + 1) + ".", 1),
                  createElementVNode("td", _hoisted_48, toDisplayString(((_a2 = item.getProduct()) == null ? void 0 : _a2.code) || ""), 1),
                  createElementVNode("td", _hoisted_49, [
                    createElementVNode("span", null, toDisplayString(item.name), 1),
                    item.getTaxRateLabel() ? (openBlock(), createElementBlock("span", _hoisted_50, " (" + toDisplayString(item.getTaxRateLabel()) + ")", 1)) : createCommentVNode("", true),
                    item.getProduct() ? (openBlock(), createElementBlock("span", _hoisted_51, "/" + toDisplayString((_b2 = item.getProduct()) == null ? void 0 : _b2.getUnitOfMeasureSold()), 1)) : createCommentVNode("", true),
                    item.gtin ? (openBlock(), createElementBlock("div", _hoisted_52, "GTIN: " + toDisplayString(item.gtin), 1)) : createCommentVNode("", true)
                  ]),
                  createElementVNode("td", _hoisted_53, toDisplayString(Math.abs(item.getCount())), 1),
                  createElementVNode("td", _hoisted_54, toDisplayString(item.getUnitPriceBeforeTax().toFormat("0,0.0000")), 1),
                  createElementVNode("td", _hoisted_55, toDisplayString(item.getTaxRate()) + "%", 1),
                  createElementVNode("td", _hoisted_56, toDisplayString(item.getUnitPriceAfterTax().toFormat(priceFormat)), 1),
                  createElementVNode("td", _hoisted_57, toDisplayString(item.getDiscountPercent()) + "%", 1),
                  createElementVNode("td", _hoisted_58, toDisplayString(item.getUnitPriceAfterDiscount().abs().toFormat(priceFormat)), 1),
                  createElementVNode("td", _hoisted_59, toDisplayString(item.getPriceBeforeTax().toFormat(priceFormat)), 1),
                  createElementVNode("td", _hoisted_60, toDisplayString(item.getTax().toFormat(priceFormat)), 1),
                  createElementVNode("td", _hoisted_61, toDisplayString(item.getToPay().toFormat(priceFormat)), 1)
                ], 2),
                __props.isRetail && item.comments.length ? (openBlock(), createElementBlock("tr", {
                  key: `invoice-item-comment-${index}`,
                  class: normalizeClass({ "border-bottom": index != __props.order.items.length - 1 })
                }, [
                  _cache[1] || (_cache[1] = createElementVNode("td", null, null, -1)),
                  _cache[2] || (_cache[2] = createElementVNode("td", null, null, -1)),
                  createElementVNode("td", _hoisted_62, [
                    createElementVNode("span", {
                      style: { "font-size": "11px" },
                      innerHTML: unref(nl2br)(item.comments[0])
                    }, null, 8, _hoisted_63)
                  ])
                ], 2)) : createCommentVNode("", true)
              ], 64);
            }), 128)),
            _cache[3] || (_cache[3] = createElementVNode("tr", { class: "divider" }, [
              createElementVNode("td", { colspan: 12 })
            ], -1))
          ])
        ])),
        !["Normal", "Advance"].includes(invoice.value.invoiceType) ? (openBlock(), createBlock(_sfc_main$1, {
          key: 3,
          text: unref(t)("receipt.nonfiscal_receipt"),
          large: true,
          delimiter: "="
        }, null, 8, ["text"])) : createCommentVNode("", true),
        createElementVNode("div", _hoisted_64, [
          createElementVNode("div", _hoisted_65, [
            createElementVNode("p", null, [
              invoice.value.invoiceType === "Advance" ? (openBlock(), createElementBlock("span", _hoisted_66, toDisplayString(unref(t)("receipt.time_pos")) + ": " + toDisplayString(unref(formatDateTime)(unref(moment)(invoice.value.dateAndTimeOfIssue || void 0).tz("Europe/Belgrade"))), 1)) : createCommentVNode("", true),
              invoice.value.referentDocumentNumber ? (openBlock(), createElementBlock("span", _hoisted_67, toDisplayString(unref(t)("receipt.ref_number")) + ": " + toDisplayString(invoice.value.referentDocumentNumber), 1)) : createCommentVNode("", true),
              invoice.value.referentDocumentDT ? (openBlock(), createElementBlock("span", _hoisted_68, toDisplayString(unref(t)("receipt.ref_time")) + ": " + toDisplayString(unref(formatDateTime)(invoice.value.referentDocumentDT)), 1)) : createCommentVNode("", true),
              createElementVNode("span", _hoisted_69, toDisplayString(unref(t)("receipt.number")) + ": " + toDisplayString(invoice.value.invoiceNumber), 1),
              createElementVNode("span", _hoisted_70, [
                createTextVNode(toDisplayString(unref(t)("receipt.sdc.number")) + ": ", 1),
                sdcResponse.value ? (openBlock(), createElementBlock("span", _hoisted_71, toDisplayString(sdcResponse.value.invoiceNumber), 1)) : (openBlock(), createElementBlock("span", _hoisted_72, "XXXXXXXX-YYYYYYYY-XYZ"))
              ]),
              createElementVNode("span", _hoisted_73, [
                createTextVNode(toDisplayString(unref(t)("receipt.sdc.time")) + ": ", 1),
                sdcResponse.value ? (openBlock(), createElementBlock("span", _hoisted_74, toDisplayString(unref(moment)(sdcResponse.value.sdcDateTime).tz("Europe/Belgrade").format("DD.MM.YYYY. HH:mm:ss")), 1)) : (openBlock(), createElementBlock("span", _hoisted_75, toDisplayString(unref(moment)().tz("Europe/Belgrade").format("DD.MM.YYYY. HH:mm:ss")), 1))
              ]),
              createElementVNode("span", _hoisted_76, [
                createTextVNode(toDisplayString(unref(t)("receipt.sdc.counter")) + ": ", 1),
                sdcResponse.value ? (openBlock(), createElementBlock("span", _hoisted_77, toDisplayString(sdcResponse.value.invoiceCounter), 1)) : (openBlock(), createElementBlock("span", _hoisted_78, "XY/XYZ"))
              ])
            ]),
            invoice.value.invoiceType === "Copy" && invoice.value.transactionType === "Refund" ? (openBlock(), createElementBlock("div", _hoisted_79, [
              createElementVNode("div", _hoisted_80, [
                _cache[4] || (_cache[4] = createElementVNode("div", null, "___________________________", -1)),
                createElementVNode("div", null, toDisplayString(unref(t)("receipt.buyer_signature")), 1)
              ])
            ])) : createCommentVNode("", true)
          ]),
          createElementVNode("div", _hoisted_81, [
            !__props.options.preview && qrCode.value ? (openBlock(), createBlock(_component_vue_qrcode, {
              key: 0,
              value: qrCode.value,
              options: {
                errorCorrectionLevel: "L",
                margin: 0,
                scale: 6
              },
              tag: "img",
              width: "170",
              height: "170"
            }, null, 8, ["value"])) : createCommentVNode("", true),
            !__props.options.preview && qrCode.value ? (openBlock(), createElementBlock("div", _hoisted_82, [
              createElementVNode("a", {
                target: "_blank",
                href: qrCode.value
              }, toDisplayString(unref(t)("receipt.verify")), 9, _hoisted_83)
            ])) : createCommentVNode("", true)
          ]),
          createElementVNode("div", _hoisted_84, [
            invoice.value.transactionType === "Sale" ? (openBlock(), createElementBlock("div", _hoisted_85, [
              createElementVNode("p", null, toDisplayString(unref(t)("receipt.payments.to_pay_sale")) + ":", 1),
              sdcResponse.value ? (openBlock(), createElementBlock("p", _hoisted_86, toDisplayString(summary.value.totalAmount.toFormat(priceFormat)), 1)) : (openBlock(), createElementBlock("p", _hoisted_87, toDisplayString(props.order.getToPay().abs().toFormat(priceFormat)), 1))
            ])) : (openBlock(), createElementBlock("div", _hoisted_88, [
              createElementVNode("p", null, toDisplayString(unref(t)("receipt.payments.to_pay_refund")) + ":", 1),
              sdcResponse.value ? (openBlock(), createElementBlock("p", _hoisted_89, toDisplayString(summary.value.totalAmount.toFormat(priceFormat)), 1)) : (openBlock(), createElementBlock("p", _hoisted_90, toDisplayString(props.order.getToPay().abs().toFormat(priceFormat)), 1))
            ])),
            (openBlock(true), createElementBlock(Fragment, null, renderList(paymentTypes.value, (paymentType, index) => {
              return openBlock(), createElementBlock("div", {
                key: index,
                class: "summary-item"
              }, [
                createElementVNode("p", null, toDisplayString(paymentType.display) + ":", 1),
                createElementVNode("p", _hoisted_91, toDisplayString(unref(Money).parse(paymentType.amount).abs().toFormat(priceFormat)), 1)
              ]);
            }), 128)),
            sdcResponse.value ? (openBlock(), createElementBlock("table", _hoisted_92, [
              createElementVNode("tbody", null, [
                createElementVNode("tr", _hoisted_93, [
                  createElementVNode("td", _hoisted_94, toDisplayString(unref(t)("receipt.taxes.label")), 1),
                  createElementVNode("td", _hoisted_95, toDisplayString(unref(t)("receipt.taxes.name")), 1),
                  createElementVNode("td", _hoisted_96, toDisplayString(unref(t)("receipt.taxes.rate")), 1),
                  createElementVNode("td", _hoisted_97, toDisplayString(unref(t)("receipt.taxes.amount")), 1)
                ]),
                (openBlock(true), createElementBlock(Fragment, null, renderList(sdcResponse.value.taxItems, (taxItem, index) => {
                  return openBlock(), createElementBlock("tr", { key: index }, [
                    createElementVNode("td", _hoisted_98, toDisplayString(taxItem.label), 1),
                    createElementVNode("td", _hoisted_99, toDisplayString(taxItem.categoryName), 1),
                    createElementVNode("td", _hoisted_100, toDisplayString(taxItem.rate) + "%", 1),
                    createElementVNode("td", _hoisted_101, toDisplayString(unref(Money).parse(taxItem.amount).toFormat(priceFormat)), 1)
                  ]);
                }), 128)),
                ((_g = __props.venue) == null ? void 0 : _g.wholesale) ? (openBlock(), createElementBlock("tr", _hoisted_102, [
                  createElementVNode("td", _hoisted_103, toDisplayString(unref(t)("receipt.taxes.total_price_before_tax")) + ": ", 1),
                  summary.value.totalPriceBeforeTax ? (openBlock(), createElementBlock("td", _hoisted_104, toDisplayString(summary.value.totalPriceBeforeTax.toFormat(priceFormat)), 1)) : createCommentVNode("", true)
                ])) : createCommentVNode("", true),
                createElementVNode("tr", _hoisted_105, [
                  createElementVNode("td", _hoisted_106, toDisplayString(unref(t)("receipt.taxes.total")) + ": ", 1),
                  createElementVNode("td", _hoisted_107, toDisplayString(summary.value.totalTax.toFormat(priceFormat)), 1)
                ])
              ])
            ])) : createCommentVNode("", true)
          ])
        ]),
        createVNode(_sfc_main$1, {
          text: ["Normal", "Advance"].includes(invoice.value.invoiceType) ? unref(t)("receipt.fiscal_receipt_end") : unref(t)("receipt.nonfiscal_receipt"),
          large: !["Normal", "Advance"].includes(invoice.value.invoiceType),
          delimiter: "="
        }, null, 8, ["text", "large"]),
        createElementVNode("div", _hoisted_108, [
          createElementVNode("div", _hoisted_109, [
            __props.order.note ? (openBlock(), createElementBlock("p", _hoisted_110, toDisplayString(__props.order.note), 1)) : createCommentVNode("", true),
            ((_h = client.value) == null ? void 0 : _h.comment) ? (openBlock(), createElementBlock("p", _hoisted_111, toDisplayString((_i = client.value) == null ? void 0 : _i.comment), 1)) : createCommentVNode("", true),
            advanceRefundInvoice.value ? (openBlock(), createElementBlock("p", _hoisted_112, toDisplayString(unref(t)("receipt.last_advance_receipt")) + ": " + toDisplayString(advanceRefundInvoice.value.referentDocumentNumber) + " " + toDisplayString(unref(moment)(advanceRefundInvoice.value.referentDocumentDT).tz("Europe/Belgrade").format("DD.MM.YYYY.")), 1)) : createCommentVNode("", true),
            vatNote.value ? (openBlock(), createElementBlock("p", _hoisted_113, toDisplayString(vatNote.value), 1)) : createCommentVNode("", true),
            createElementVNode("div", _hoisted_114, [
              createElementVNode("div", _hoisted_115, [
                _cache[5] || (_cache[5] = createElementVNode("div", null, "___________________________", -1)),
                createElementVNode("div", null, toDisplayString(unref(t)("receipt.delivered_by")), 1)
              ]),
              createElementVNode("div", _hoisted_116, [
                _cache[6] || (_cache[6] = createElementVNode("div", null, "___________________________", -1)),
                createElementVNode("div", null, toDisplayString(unref(t)("receipt.received_by")), 1)
              ])
            ])
          ]),
          createVNode(_sfc_main$2, {
            order: __props.order,
            venue: __props.venue
          }, null, 8, ["order", "venue"])
        ])
      ]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=index18.js.map
